module.exports = __webpack_public_path__ + "img/lamp-on.9d4e7b1d.svg";